<template>
<div class='footer'>
  <div class="footer-container">
 <Row type='flex' justify='center' align='middle'>
  <Col span='12'>
    <div class='img-list'>
      <div class='yhy-zzh'>
        <div>
          <img src='img/yhy.png' width="64" height="auto"/>
        </div>
        <div>颐和园公众号</div>
      </div>
      <div class='yhy-zzh'>
        <div>
          <img src='img/yhyzx.png' width="64" height="auto"/>
        </div>
        <div>官方购票公众号</div>
      </div>
      <div class='yhy-zzh'>
        <div>
          <img src='img/yhywb.png' width="64" height="auto"/>
        </div>
        <div>颐和园微博</div>
      </div>
    </div>
  </Col>
    <Col span='12'>
      <div>本系统由北京先进数通信息技术股份公司提供服务支持</div>
      <div>客服电话:  010-62860608 </div>
      <div>北京颐和园管理处页面版权所有   I京ICP备05050248</div>
    </Col>
  </Row>
  </div>
</div>
</template>

<script>
export default {
}
</script>

<style scoped lang="less">
.yhy-zzh{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
  font-size: 12px;
}
.footer{
  width:100% ;
  background-color: @footer;
  padding: 20px;
  font-weight: 500;
  color: @font-white;
}
.footer-container{
  width:1200px;
  margin: 0 auto;
}
.img-list{
  display: flex;
  margin-left:20px;
}
</style>
